import LabelForm from '../components/LabelForm';

export default {
  init() {
    const form = document.getElementById('label-form');
    if (!form || form.dataset.milLabelFormInit) {
      return;
    }
    form.dataset.milLabelFormInit = '1';
    new LabelForm(form);
  },
  finalize() {
    // JavaScript to be fired on the label page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/label.js